/**
 * Extract cross domain settings from analytics file data
 *
 * @param {object} analyticsFileData - Analytics file data
 * @returns {object|undefined} Cross domain settings
 */
export default function getCrossDomainSettings(analyticsFileData) {
  const identitySyncs = analyticsFileData?.identitySyncs ?? [];
  const crossDomainSync = identitySyncs.find(sync => sync.name === 'crossDomain');
  return crossDomainSync?.settings;
}
